var render = function render(){var _vm=this,_c=_vm._self._c;return _c('member-list',{attrs:{"gender":"male","title-key":"memberList.maleTitle"}})
}
var staticRenderFns = []

export { render, staticRenderFns }